<div [class]="wrapperClass()">
  <div class="wrapper-image">
    <ngx-skeleton-loader
      [theme]="{height: '85px', width: '85px', 'border-radius':'0'}"
      appearance="circle"
    ></ngx-skeleton-loader>
  </div>

  <div class="wrapper-content">
    <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
  </div>

  @if (displayListView()) {
    <div class="wrapper-attributes swiper-no-swiping">
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
    </div>
  }
</div>
